export const isMediaAccessDenied = (error: unknown): boolean => {
    if (error instanceof DOMException) {
        return (
            error.name === 'NotAllowedError' || error.name === 'SecurityError' || error.name === 'PermissionDeniedError'
        );
    }

    if (error instanceof Error) {
        return error.name === 'NotAllowedError' || /permission denied/i.test(error.message);
    }

    return false;
};
